<template>
  <!-- Mismo diseño que LoginComponent. modo "crear": enlace del correo (invitación o recuperación);
       modo "olvido": pedir el correo de recuperación -->
  <div class="auth-shell">
    <div class="auth-glow auth-glow--left"></div>
    <div class="auth-glow auth-glow--right"></div>

    <v-container fluid class="auth-frame pa-4 pa-md-8">
      <v-row class="auth-stage ma-0" align="center" justify="center">
        <v-col cols="12" md="10" lg="8" xl="7" class="auth-column pa-0">
          <v-card class="auth-card" elevation="16">
            <div class="auth-grid">

              <!-- Panel izquierdo (solo desktop) -->
              <aside class="brand-panel d-none d-md-flex">
                <div class="brand-wrap">
                  <v-img src="../assets/logoWhite.png" contain class="brand-logo" />
                  <div class="brand-copy text-center">
                    Plataforma de monitorización y control de riego inteligente.
                  </div>
                </div>
              </aside>

              <!-- Panel derecho -->
              <section class="form-panel">
                <div class="mobile-header d-flex d-md-none align-center mb-6">
                  <v-img src="../assets/logoWhite.png" contain class="mobile-logo" />
                  <div class="ml-3">
                    <div class="mobile-title">SmartWater</div>
                    <div class="mobile-subtitle">Plataforma de monitorización y control de riego inteligente</div>
                  </div>
                </div>

                <span class="demo-pill">VERSIÓN DEMO</span>

                <!-- Comprobando el enlace -->
                <div v-if="comprobando" class="d-flex justify-center my-12">
                  <v-progress-circular indeterminate color="teal darken-2" size="40" />
                </div>

                <!-- Enlace no válido, usado o caducado -->
                <div v-else-if="errorEnlace">
                  <div class="form-header">
                    <div class="form-title">Enlace no disponible</div>
                    <p class="form-subtitle">{{ errorEnlace }}</p>
                  </div>
                  <v-btn class="login-btn mt-6" block large depressed @click="irA('OlvidePassword')">
                    Pedir un enlace nuevo
                  </v-btn>
                  <div class="form-note">
                    <a href="#/Login" class="link" @click.prevent="irAlLogin">Volver a iniciar sesión</a>
                  </div>
                </div>

                <!-- Hecho -->
                <div v-else-if="hecho">
                  <div class="text-center">
                    <v-avatar color="teal lighten-5" size="72" class="mb-4">
                      <v-icon size="40" color="teal darken-2">{{ modo === 'olvido' ? 'mdi-email-check-outline' : 'mdi-check-circle-outline' }}</v-icon>
                    </v-avatar>
                  </div>
                  <div class="form-header text-center">
                    <div class="form-title">{{ modo === 'olvido' ? 'Revisa tu correo' : 'Contraseña guardada' }}</div>
                    <p class="form-subtitle">
                      <template v-if="modo === 'olvido'">
                        Si el email está registrado, recibirás un enlace para restablecer tu contraseña.
                        El enlace dura 30 minutos.
                      </template>
                      <template v-else>Ya puedes iniciar sesión con tu correo y tu nueva contraseña.</template>
                    </p>
                  </div>
                  <v-btn class="login-btn mt-6" block large depressed @click="irAlLogin">
                    Iniciar sesión
                  </v-btn>
                </div>

                <!-- Formulario: crear / restablecer contraseña -->
                <div v-else-if="modo === 'crear'">
                  <div class="form-header">
                    <div class="form-title">{{ esOlvido ? 'Restablecer contraseña' : 'Crea tu contraseña' }}</div>
                    <p class="form-subtitle">
                      Elige una contraseña para <strong>{{ email }}</strong>. Debe tener al menos 5 caracteres.
                    </p>
                  </div>

                  <v-form ref="form" class="mt-6" @submit.prevent="guardar">
                    <v-text-field v-model="password" label="Nueva contraseña" outlined dense
                      prepend-inner-icon="mdi-lock-outline" :type="ver ? 'text' : 'password'"
                      :append-icon="ver ? 'mdi-eye' : 'mdi-eye-off'" @click:append="ver = !ver"
                      autocomplete="new-password" :disabled="cargando" color="teal darken-2" class="mb-2"
                      :rules="[v => (v || '').length >= 5 || 'Mínimo 5 caracteres']" />
                    <v-text-field v-model="repetir" label="Repite la contraseña" outlined dense
                      prepend-inner-icon="mdi-lock-check-outline" :type="ver ? 'text' : 'password'"
                      autocomplete="new-password" :disabled="cargando" color="teal darken-2"
                      :rules="[v => v === password || 'Las contraseñas no coinciden']" />

                    <transition name="expand">
                      <div v-if="error" class="error-box mt-4">
                        <v-icon size="18" class="mr-2" color="error">mdi-alert-circle-outline</v-icon>
                        <span>{{ error }}</span>
                      </div>
                    </transition>

                    <v-btn class="login-btn mt-6" block large type="submit" depressed
                      :disabled="password.length < 5 || password !== repetir || cargando">
                      <v-progress-circular v-if="cargando" indeterminate size="18" width="2" class="mr-2" color="white" />
                      Guardar contraseña
                    </v-btn>
                  </v-form>
                </div>

                <!-- Formulario: he olvidado la contraseña -->
                <div v-else>
                  <div class="form-header">
                    <div class="form-title">¿Has olvidado la contraseña?</div>
                    <p class="form-subtitle">Escribe tu correo y te enviaremos un enlace para crear una nueva.</p>
                  </div>

                  <v-form ref="form" class="mt-6" @submit.prevent="enviarOlvido">
                    <v-text-field v-model="email" label="Correo electrónico" outlined dense type="email"
                      prepend-inner-icon="mdi-email-outline" autocomplete="username" :disabled="cargando"
                      color="teal darken-2" />

                    <v-btn class="login-btn mt-4" block large type="submit" depressed :disabled="!emailValido || cargando">
                      <v-progress-circular v-if="cargando" indeterminate size="18" width="2" class="mr-2" color="white" />
                      Enviar enlace
                    </v-btn>
                  </v-form>
                  <div class="form-note">
                    <a href="#/Login" class="link" @click.prevent="irAlLogin">Volver a iniciar sesión</a>
                  </div>
                </div>
              </section>

            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

const API = () => process.env.VUE_APP_API_URL;

export default {
  name: "PasswordComponent",
  props: {
    modo: { type: String, default: "crear" }, // "crear" | "olvido"
  },
  data() {
    return {
      comprobando: this.modo === "crear",
      errorEnlace: "",
      email: "",
      password: "",
      repetir: "",
      ver: false,
      cargando: false,
      error: "",
      hecho: false,
    };
  },
  computed: {
    token() {
      return this.$route.params.token || "";
    },
    esOlvido() {
      return this.$route.query.olvido === "1";
    },
    emailValido() {
      return /.+@.+\..+/.test(this.email.trim());
    },
  },
  mounted() {
    if (this.modo === "crear") this.verificar();
  },
  methods: {
    mensaje(error, porDefecto) {
      return error?.response?.data?.message || porDefecto;
    },
    async verificar() {
      try {
        const { data } = await axios.post(`${API()}/reset-password/verificar`, { token: this.token });
        this.email = data.email;
      } catch (error) {
        this.errorEnlace = this.mensaje(error, "No se ha podido comprobar el enlace. Inténtalo de nuevo.");
      } finally {
        this.comprobando = false;
      }
    },
    async guardar() {
      this.error = "";
      this.cargando = true;
      try {
        await axios.post(`${API()}/reset-password`, { token: this.token, password: this.password });
        this.hecho = true;
      } catch (error) {
        this.error = this.mensaje(error, "No se pudo guardar la contraseña. Inténtalo de nuevo.");
      } finally {
        this.cargando = false;
      }
    },
    async enviarOlvido() {
      this.cargando = true;
      try {
        await axios.post(`${API()}/forgot-password`, { email: this.email.trim() });
      } catch {
        // Misma respuesta exista o no el correo
      } finally {
        this.cargando = false;
        this.hecho = true;
      }
    },
    irA(name) {
      if (this.$route.name !== name) this.$router.push({ name });
    },
    // Se cierra cualquier sesión abierta antes de ir al login
    irAlLogin() {
      localStorage.clear();
      this.$router.push("/Login");
    },
  },
};
</script>

<style scoped>
.auth-shell { position: fixed; inset: 0; z-index: 200; overflow: hidden; }
.auth-glow { position: absolute; border-radius: 999px; filter: blur(24px); opacity: 0.55; pointer-events: none; }
.auth-glow--left { top: 70px; left: -80px; width: 220px; height: 220px; background: rgba(0, 121, 107, 0.2); }
.auth-glow--right { right: -110px; bottom: 40px; width: 260px; height: 260px; background: rgba(13, 148, 136, 0.16); }
.auth-frame { min-height: 100vh; background: #f6f7fb; display: flex; align-items: center; justify-content: center; }
.auth-stage { width: 100%; min-height: calc(100vh - 32px); align-items: center; justify-content: center; }
.auth-column { display: flex; align-items: center; justify-content: center; }
.auth-card {
  position: relative; width: 100%; overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
  background: rgba(255, 255, 255, 0.88) !important;
  border-radius: 16px !important;
}
.auth-grid { display: grid; grid-template-columns: 1fr; min-height: 585px; }
@media (min-width: 960px) {
  .auth-grid { grid-template-columns: 42% 58%; min-height: 525px; }
}
.brand-panel { background: linear-gradient(135deg, #003830, #004d40); display: flex; align-items: center; justify-content: center; padding: 28px; }
.brand-wrap { position: relative; z-index: 1; max-width: 250px; width: 100%; margin: 0 auto; color: white; text-align: center; }
.brand-logo { display: block; max-width: 230px; height: 152px; margin: 34px auto 0; filter: drop-shadow(0 14px 28px rgba(0, 0, 0, 0.22)); }
.brand-copy { font-size: 12px; opacity: 0.85; color: white; }
.form-panel { display: flex; flex-direction: column; justify-content: center; padding: 26px 22px; background: rgba(255, 255, 255, 0.96); }
@media (min-width: 960px) {
  .form-panel { padding: 42px 42px; }
}
.mobile-header { padding: 16px 18px; border-radius: 22px; background: linear-gradient(145deg, rgba(0, 63, 54, 0.94), rgba(0, 115, 98, 0.9)); color: white; }
.mobile-logo { width: 118px; height: 38px; flex: 0 0 auto; }
.mobile-title { font-size: 16px; font-weight: 800; color: white; }
.mobile-subtitle { margin-top: 2px; font-size: 12px; color: rgba(255, 255, 255, 0.78); }
.demo-pill {
  align-self: flex-start; margin-bottom: 14px; padding: 4px 12px; border-radius: 999px;
  font-size: 11px; font-weight: 800; letter-spacing: 1px;
  color: #e65100; background: #fff3e0; border: 1px solid #ffcc80;
}
.form-title { font-size: 24px; font-weight: 900; }
.form-subtitle { margin: 12px 0 0; color: rgba(15, 23, 42, 0.62); font-size: 14px; line-height: 1.65; word-break: break-word; }
.error-box {
  display: flex; align-items: center; border-radius: 14px; padding: 12px 14px; font-size: 12px;
  color: #b42318; background: rgba(180, 35, 24, 0.08); border: 1px solid rgba(180, 35, 24, 0.18);
}
.login-btn {
  min-height: 50px !important; border-radius: 16px !important; text-transform: none !important;
  font-size: 15px !important; font-weight: 800 !important; letter-spacing: 0.01em !important;
  background: linear-gradient(135deg, #00594d, #004d40) !important; color: white !important;
  box-shadow: 0 16px 34px rgba(0, 77, 64, 0.2) !important;
}
.login-btn.v-btn--disabled { opacity: 0.55; color: rgba(255, 255, 255, 0.9) !important; }
.form-note { margin-top: 18px; font-size: 12px; text-align: center; color: rgba(15, 23, 42, 0.46); }
.link { color: #00796b; text-decoration: none; font-weight: 600; }
.expand-enter-active, .expand-leave-active { transition: opacity 0.2s ease, transform 0.2s ease; }
.expand-enter, .expand-leave-to { opacity: 0; transform: translateY(-6px); }
</style>
